import React from 'react';
import {Link} from 'react-router-dom'

const SoftwareDevelopment = () => {
  return (
    <section id="software-development" className="py-16 bg-gradient-to-br from-indigo-600 to-teal-600">
      <div className="container mx-auto px-4">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
            DEVGENIUS SOFTWARE SOLUTIONS
          </h2>
          <p className="text-indigo-100 text-lg max-w-3xl mx-auto">
            Custom Software Solutions to Power Your Digital Future
          </p>
        </div>

        {/* Software Development Card */}
        <div className="max-w-4xl mx-auto">
          <div className="bg-white rounded-2xl shadow-2xl overflow-hidden hover:transform hover:scale-105 transition-all duration-300">
            <div className="relative">
              <img 
                src="/assets/Soft Dev2.png" 
                alt="DevGenius Software Solutions" 
                className="w-full h-64 object-cover"
              />
              <div className="absolute top-4 left-4 bg-gradient-to-r from-indigo-500 to-yellow-500 text-white px-3 py-1 rounded-full text-sm font-semibold flex items-center">
                <span className="animate-pulse mr-2">💻</span> TECH INNOVATION
              </div>
            </div>
            
            <div className="p-8">
              <h3 className="text-2xl font-bold text-gray-800 mb-3">
                Accelerate your business growth with DevGenius
              </h3>
              <p className="text-indigo-600 font-semibold mb-4 text-lg">
                Your trusted partner for cutting-edge software development across Africa
              </p>
              
              <p className="text-gray-600 mb-6 leading-relaxed">
                Whether you need a bespoke application, system integration, or digital transformation, <strong>DevGenius</strong> delivers scalable, secure, and innovative solutions tailored to your unique needs. Designed specifically for African businesses with local market understanding and global tech standards.
              </p>

              <div className="mb-6">
                <h4 className="font-bold text-gray-800 mb-3">Why Choose DevGenius?</h4>
                <div className="space-y-2">
                  <div className="flex items-start">
                    <span className="text-indigo-500 mr-2 text-lg">✔</span>
                    <span className="text-gray-700"><strong>End-to-End Development</strong> - Web, mobile, desktop, and cloud applications from concept to deployment.</span>
                  </div>
                  <div className="flex items-start">
                    <span className="text-indigo-500 mr-2 text-lg">✔</span>
                    <span className="text-gray-700"><strong>Industry-Specific Solutions</strong> - Custom-built for healthcare, finance, education, and retail sectors.</span>
                  </div>
                  <div className="flex items-start">
                    <span className="text-indigo-500 mr-2 text-lg">✔</span>
                    <span className="text-gray-700"><strong>Seamless Integration</strong> - Connect with ERPs, CRMs, and payment gateways for smooth operations.</span>
                  </div>
                  <div className="flex items-start">
                    <span className="text-indigo-500 mr-2 text-lg">✔</span>
                    <span className="text-gray-700"><strong>Agile & Scalable</strong> - Future-proof solutions designed to grow with your business.</span>
                  </div>
                  <div className="flex items-start">
                    <span className="text-indigo-500 mr-2 text-lg">✔</span>
                    <span className="text-gray-700"><strong>Dedicated Support</strong> - Ongoing maintenance, updates, and 24/7 technical assistance.</span>
                  </div>
                </div>
              </div>

              <div className="mb-6">
                <h4 className="font-bold text-gray-800 mb-3">Perfect For:</h4>
                <div className="bg-gradient-to-r from-indigo-50 to-teal-50 rounded-lg p-4 border border-indigo-100">
                  <div className="grid md:grid-cols-2 gap-3 text-gray-700">
                    <div className="flex items-start">
                      <span className="text-teal-600 mr-2">•</span>
                      <span>Startups & SMEs <em>(Build your dream app or SaaS platform)</em></span>
                    </div>
                    <div className="flex items-start">
                      <span className="text-teal-600 mr-2">•</span>
                      <span>Enterprises <em>(Modernize legacy systems or automate workflows)</em></span>
                    </div>
                    <div className="flex items-start">
                      <span className="text-teal-600 mr-2">•</span>
                      <span>Government & NGOs <em>(Digitize services for efficiency)</em></span>
                    </div>
                  </div>
                </div>
              </div>

              <div className="mb-6">
                <h4 className="font-bold text-gray-800 mb-3">Key Services:</h4>
                <div className="bg-gray-50 rounded-lg p-4">
                  <div className="grid md:grid-cols-2 gap-3 text-gray-700">
                    <div className="flex items-start">
                      <span className="text-yellow-500 mr-2">•</span>
                      <span>Web & Mobile Apps <em>(User-friendly, cross-platform applications)</em></span>
                    </div>
                    <div className="flex items-start">
                      <span className="text-yellow-500 mr-2">•</span>
                      <span>API Development <em>(Secure and scalable integrations)</em></span>
                    </div>
                    <div className="flex items-start">
                      <span className="text-yellow-500 mr-2">•</span>
                      <span>AI & IoT Solutions <em>(Smart automation and predictive analytics)</em></span>
                    </div>
                    <div className="flex items-start">
                      <span className="text-yellow-500 mr-2">•</span>
                      <span>Blockchain Development <em>(Fintech and logistics solutions)</em></span>
                    </div>
                  </div>
                </div>
              </div>

              <p className="text-indigo-600 font-semibold mb-6 text-center text-lg flex justify-center items-center">
                <span className="mr-2">Turn your vision into reality - partner with DevGenius today!</span>
                <span className="text-2xl">💻</span>
              </p>

              <Link
                to="/contact"  // Make sure this matches your registration route
                className="inline-flex items-center justify-center w-full bg-gradient-to-r from-blue-600 to-green-600 text-white py-3 px-6 rounded-lg font-semibold hover:from-blue-700 hover:to-green-700 shadow-lg hover:shadow-xl transform hover:-translate-y-1 transition-all duration-300 ease-in-out"
              >
                <span>Build Something Amazing Now !</span>
                <svg 
                  className="w-5 h-5 ml-2 transform group-hover:translate-x-1 transition-transform duration-300" 
                  fill="none" 
                  stroke="currentColor" 
                  viewBox="0 0 24 24"
                >
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 7l5 5m0 0l-5 5m5-5H6"></path>
                </svg>
              </Link>
            </div>
          </div>
        </div>

        {/* Bottom CTA */}
        <div className="text-center mt-16">
          <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-8 max-w-4xl mx-auto border border-white/20">
            <h3 className="text-2xl font-bold text-white mb-4">
              Ready to Transform Your Business with Custom Software?
            </h3>
            <p className="text-indigo-100 mb-6 text-lg">
              Join organizations across Africa that are innovating with DevGenius solutions
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
                          <Link
                            to="/contact"
                            className="inline-flex items-center justify-center bg-gradient-to-r from-blue-600 to-green-600 text-white px-8 py-3 rounded-lg font-semibold hover:from-blue-700 hover:to-green-700 shadow-lg hover:shadow-xl transform hover:-translate-y-1 transition-all duration-300 ease-in-out"
                          >
                            Talk To Our Team
                          </Link>
                          {/* <Link
                            to="/contact"
                            className="inline-flex items-center justify-center border-2 border-white text-white px-8 py-3 rounded-lg font-semibold hover:bg-white hover:text-blue-600 shadow-lg hover:shadow-xl transform hover:-translate-y-1 transition-all duration-300 ease-in-out"
                          >
                            Talk To Us
                          </Link> */}
                        </div>
            <p className="text-yellow-200 mt-6 text-sm">
              Powered by Infinity Tech Africa. Create. Transform.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SoftwareDevelopment;